import {snakify} from '../snakify';
import {camelize} from '../camelize';
import {ISerializable} from 'cerialize';
import {OnboardingStep} from '../../models/onboarding-step';

export const OnboardingStepTransformer: ISerializable = {
  Serialize(value: OnboardingStep): string {
    return snakify(OnboardingStep[value]);
  },
  Deserialize(json: any): any {
    if (json) {
      const valueName = camelize(json, true);
      return OnboardingStep[valueName];
    }
    return OnboardingStep.EventDate;
  }
};
